/**
 * User: 胡伯 <hubo.hb@taobao.com>,勇智 <yongzhi.wyz@taobao.com>
 * 为广告点击加入spm.依赖spm.js
 */

;(function () {
    var win = window,
        doc = document,
        loc = location,
        page_url = loc.href,
        sw = win._alimm_spmact_on_;
    //spmact是否开启状态，默认为开启
    if(typeof sw == "undefined"){
        sw = 1;
//        var p1 = Math.floor(Math.random()*100+1),
//            p2 = 50;
//        sw = ((p1 <= p2) ? 1 : 0);
    }
    if(sw == 1){
        sw = 1;
    }
    if(sw == 0){
        sw = 0;
    }


    if(!sw){
        return;
    }
    try{
        //在CRM中诡异的报错：getParam undefined
        var spmapi = win.g_SPM.getParam;
    }catch(e){
        spmapi = function(){
            return {
                a:0,b:0,c:0,d:0,e:0
            }
        };
    }
    var bInIframe = true;
    try {
        bInIframe = (self.location != top.location);
    } catch (e) {
    }
    var sATTR_DATA_SPM_ACT_ID = "data-spm-act-id";
    var ad_links = [
        "mclick.simba.taobao.com", // 无线点击
        "click.simba.taobao.com", // kgb的点击
        "click.tanx.com", // tanx的点击
        "click.mz.simba.taobao.com", // mama的点击
        "click.tz.simba.taobao.com", // mama的点击
        "redirect.simba.taobao.com", // redirect点击
        "rdstat.tanx.com", // redirect地址
        "stat.simba.taobao.com", // 隐樵 2012-5-20
        "s.click.taobao.com" // 隐樵 2012-5-20
    ]
    /**
     * 绑定事件
     * @param obj {Element} DOM 元素
     * @param event_type
     * @param f
     */
    // 当前浏览器是否为 IE（是否支持 document.attachEvent）
    var atta = !!doc.attachEvent;
    var s_attachEvent = "attachEvent";
    var s_addEventListener = "addEventListener";
    var onevent = atta ? s_attachEvent : s_addEventListener;

    function addEventListener(obj, event_type, f) {
        obj[onevent](
            (atta ? "on" : "") + event_type,
            function (e) {
                e = e || win.event;
                var el = e.target || e.srcElement;
                f(e, el);
            },
            false
        );
    }
    function fnCurrentURLSpm() {
        if (/&?\bspm=[^&#]*/.test(location.href)) {
            return location.href.match(/&?\bspm=[^&#]*/ig)[0].split("=")[1]
        }
        return "";
    }
    function fnUpdateHrefWithSPMId(href, spm_id) {
        // 去掉现有的 href 中的 spm 参数
        if (href && /&?\bspm=[^&#]*/.test(href)) {
            href = href.replace(/&?\bspm=[^&#]*/g, "")
                .replace(/&{2,}/g, "&")
                .replace(/\?&/, "?")
                .replace(/\?$/, "")
            ;
        }

        if (!spm_id) return href;

        // 在 href 中插入新的 spm 参数
        var search, hash, a,
            and_char = "&",
            query_split,
            query_count,
            filename,
            file_ext;

        if (href.indexOf("#") != -1) {
            a = href.split("#");
            href = a.shift();
            hash = a.join("#"); // 取第一个 # 后的部分
        }
        query_split = href.split("?");
        query_count = query_split.length - 1;

        // 下面处理形如“http://www.taobao.com”这样的末尾不带“/”的链接
        // 这种链接对应的filename为空
        a = query_split[0].split("//");
        a = a[a.length - 1].split("/");
        filename = a.length > 1 ? a.pop() : "";

        if (query_count > 0) {
            /**
             * 由于存在类似 http://ju.atpanel.com/?scm=1005.10.1.703&url=http://www.tmall.com/go/act/tmall/mymx-ym.php?spm=1.1000386.222017.20&ad_id=&am_id=&cm_id=&pm_id=150100827263368085f8
             * 这样的链接，注意其中有两个“?”，
             * 这是一种跳转链接，其中 spm 参数需要加在后面一个 ? 之后，
             * 经与梵易商量（2012-03-30），决定统一将 spm 参数加到 href 的最后一个 ? 之后
             */
//			a = href.split("?");
            search = query_split.pop(); // 取最后一个 ? 后的部分
            href = query_split.join("?"); // 最后一个 ? 之前的部分
        }

        if (search &&
            query_count > 1 && // # 只对两个及以上的“?”的 url 执行这样的检测
            search.indexOf("&") == -1 &&
//			search.indexOf("=") == -1 &&
            search.indexOf("%") != -1) {
            /**
             * 有一些页面，如 http://login.taobao.com/member/logout.jhtml?f=top&redirectURL=http://login.tmall.com/?spm=1007.100361.0.180%26redirect_url=http%253A%252F%252Ftemai.tmall.com%252F%253Fspm%253D3.1000473.197562.2%2526prt%253D1336367425196%2526prc%253D4
             * spm 参数加在第二个 ? 之后，但是第二个 ? 之后的 & 都已经做了规范的转码，所以新添加的 spm 后面的 & 也要进行转码
             */
            and_char = "%26";
        }

        href = href + "?spm=" + spm_id
            + (search ? (and_char + search) : "")
            + (hash ? ("#" + hash) : "")
        ;

        /**
         * 添加文件名额外参数
         * 由于在IE下，如果加了spm参数可能会引起文件后缀名被修改，
         *
         * 比如：
         * 原始下载链接：
         * http://download.alipay.com/sec/edit/aliedit.exe
         *
         * 加了spm参数之后：
         * http://download.alipay.com/sec/edit/aliedit.exe?spm=a2107.1.1000341.10（有问题，IE下后缀名被修改为“.10”）
         *
         * 加了file参数之后：
         * http://download.alipay.com/sec/edit/aliedit.exe?spm=a2107.1.1000341.10&file=aliedit.exe（没有问题）
         *
         * 因此，这儿会对形如文件下载的链接添加一个额外参数
         */
        file_ext = filename.indexOf(".") > -1 ? filename.split(".").pop().toLowerCase() : "";
        if (file_ext) {
            if (({
                "png":1,
                "jpg":1,
                "jpeg":1,
                "gif":1,
                "bmp":1,
                "swf":1
            }).hasOwnProperty(file_ext)) {
                // 以图片后缀名结尾的链接不加 spm 参数
                return 0;
            }

            if (!search && query_count <= 1) {
                if (!hash && !({
                    "htm":1,
                    "html":1,
                    "php":1
                }).hasOwnProperty(file_ext)) {
                    // 认为当前文件是一个下载文件，添加额外参数
                    href += "&file=" + filename;
                }
            }
        }
        return href;
    };
    function fnReplacePid(url) {
        //http://cb.alimama.cn/js/replace_pid.js
        var str = window.location.href;
        var pid = str.match(/mm_\d{0,24}_\d{0,24}_\d{0,24}/i);
        var pvid = str.match(/[&\?](pvid=[^&]*)/i);
        var reg_26 = new RegExp("%3Dmm_\\d+_\\d+_\\d+", "ig");
        var reg = new RegExp("mm_\\d+_\\d+_\\d+", "ig");

        function replace_refpos(href) {
            href = href.replace(/refpos[=(%3D)]\w*/ig, refpos).replace(reg_26,
                "%3D" + pid + "%26" + pvid.replace("=", "%3D")).replace(
                reg, pid);
            if (pvid.length > 0) {
                href += "&" + pvid;
            }
            return href;
        }

        if (pvid && pvid[1]) {
            pvid = pvid[1];
        } else {
            pvid = "";
        }
        var refpos = str
            .match(/(refpos=(\d{0,24}_\d{0,24}_\d{0,24})?(,[a-z]+)?)(,[a-z]+)?/i);
        if (refpos && refpos[0]) {
            refpos = refpos[0];
        } else {
            refpos = "";
        }
        if (pid) {
            pid = pid[0];
            return replace_refpos(url);
            //不明需求，从http://cb.alimama.cn/js/replace_pid.min.js中移植过来
//        var w = str.match(/w=mmp4ptest[^&]{0,}/i);
//        if (w) {
//            var wreg = new RegExp("w=mmp4ptest[^&]{0,}", "gmi");
//            for ( var i = 0; i < as.length; i++) {
//                as[i].href = as[i].href.replace(wreg, w[0]);
//            }
//            for ( var i = 0; i < iframe.length; i++) {
//                iframe[i].src = iframe[i].src.replace(wreg, w[0]);
//            }
//        }
        }
        return url;
    };
    function domReady(f) {
        var kissy = win["KISSY"];
        if (kissy) {
            kissy.ready(f);
        } else if (win.jQuery) {
            jQuery(doc).ready(f);
        } else {
            if (doc.readyState === "complete") {
                f();
            } else {
                addEventListener(win, "load", f);
            }
        }
    };

    function tryToGetAttribute(element, attr_name) {
        return element && element.getAttribute ? (element.getAttribute(attr_name) || "") : "";
    }

    /**
     * 判断当前 url 是否广告链接
     * @param url {String}
     */
    function spm_isAdLink(url) {
        if (!url)return;
        var i, len = ad_links.length;

        for (i = 0; i < len; i++) {
            if (url.indexOf(ad_links[i]) > -1) return true;
        }

        return false;
    }

    //替换现有url中的spm参数，同spm.js中spm_updateHrefWithSPMId参数
    function spm_updateHrefWithSPMId(href, spm_id) {
        // 去掉现有的 href 中的 spm 参数
        if (href && /&?\bspm=[^&#]*/.test(href)) {
            href = href.replace(/&?\bspm=[^&#]*/g, "")
                .replace(/&{2,}/g, "&")
                .replace(/\?&/, "?")
                .replace(/\?$/, "")
            ;
        }

        if (!spm_id) return href;

        // 在 href 中插入新的 spm 参数
        var search, hash, a,
            and_char = "&",
            query_split,
            query_count,
            filename,
            file_ext;

        if (href.indexOf("#") != -1) {
            a = href.split("#");
            href = a.shift();
            hash = a.join("#"); // 取第一个 # 后的部分
        }
        query_split = href.split("?");
        query_count = query_split.length - 1;

        // 下面处理形如“http://www.taobao.com”这样的末尾不带“/”的链接
        // 这种链接对应的filename为空
        a = query_split[0].split("//");
        a = a[a.length - 1].split("/");
        filename = a.length > 1 ? a.pop() : "";

        if (query_count > 0) {
            /**
             * 由于存在类似 http://ju.atpanel.com/?scm=1005.10.1.703&url=http://www.tmall.com/go/act/tmall/mymx-ym.php?spm=1.1000386.222017.20&ad_id=&am_id=&cm_id=&pm_id=150100827263368085f8
             * 这样的链接，注意其中有两个“?”，
             * 这是一种跳转链接，其中 spm 参数需要加在后面一个 ? 之后，
             * 经与梵易商量（2012-03-30），决定统一将 spm 参数加到 href 的最后一个 ? 之后
             */
//			a = href.split("?");
            search = query_split.pop(); // 取最后一个 ? 后的部分
            href = query_split.join("?"); // 最后一个 ? 之前的部分
        }

        if (search &&
            query_count > 1 && // # 只对两个及以上的“?”的 url 执行这样的检测
            search.indexOf("&") == -1 &&
//			search.indexOf("=") == -1 &&
            search.indexOf("%") != -1) {
            /**
             * 有一些页面，如 http://login.taobao.com/member/logout.jhtml?f=top&redirectURL=http://login.tmall.com/?spm=1007.100361.0.180%26redirect_url=http%253A%252F%252Ftemai.tmall.com%252F%253Fspm%253D3.1000473.197562.2%2526prt%253D1336367425196%2526prc%253D4
             * spm 参数加在第二个 ? 之后，但是第二个 ? 之后的 & 都已经做了规范的转码，所以新添加的 spm 后面的 & 也要进行转码
             */
            and_char = "%26";
        }

        href = href + "?spm=" + spm_id
            + (search ? (and_char + search) : "")
            + (hash ? ("#" + hash) : "")
        ;

        file_ext = filename.indexOf(".") > -1 ? filename.split(".").pop().toLowerCase() : "";
        if (file_ext) {
            if (({
                "png":1,
                "jpg":1,
                "jpeg":1,
                "gif":1,
                "bmp":1,
                "swf":1
            }).hasOwnProperty(file_ext)) {
                // 以图片后缀名结尾的链接不加 spm 参数
                return 0;
            }

            if (!search && query_count <= 1) {
                if (!hash && !({
                    "htm":1,
                    "html":1,
                    "php":1
                }).hasOwnProperty(file_ext)) {
                    // 认为当前文件是一个下载文件，添加额外参数
                    href += "&__file=" + filename;
                }
            }
        }

        return href;
    }

    function spm_spmAnchor(el) {
        if (spm_isAdLink(el.href)) {
            var a_spm_id = tryToGetAttribute(el, sATTR_DATA_SPM_ACT_ID);
            if (!a_spm_id) {
                /**
                 * 当前链接没有 spm_id
                 * 递归检查它的祖先元素是否为 spm 打点元素
                 */
                if (!spmapi)return;
                var oaspm = spmapi(el), saspm = [oaspm.a, oaspm.b, oaspm.c, oaspm.d, oaspm.e].join(".");
                if (bInIframe) {
                    //在iframe里时，链接上的spm要带上ifram上的spm同时，e位是没有必要的
                    //如果父级的spm为空的，那么取0.0.0.0.0
                    saspm = [oaspm.a || '0', oaspm.b || '0', oaspm.c || '0', oaspm.d || '0'].join(".");
                    saspm = ( fnCurrentURLSpm() || '0.0.0.0.0' ) + "_" + saspm;
                }
                var spmhref = spm_updateHrefWithSPMId(el.href, saspm);
                el.href = spmhref;
                el.setAttribute(sATTR_DATA_SPM_ACT_ID, saspm);
            }
        }
        el = undefined;
    };

    addEventListener(doc, "mousedown", function (e, el) {
        var tag_name, i = 0;
        while (el && (tag_name = el.tagName) && i < 5) {
            if (tag_name == "A" || tag_name == "AREA") {
                // 点到了链接上
                spm_spmAnchor(el);
                break;
            } else if (tag_name == "BODY" || tag_name == "HTML") break;

            el = el.parentNode;
            i++;
        }
    });

    /**
     * 处理iframe
     */
    domReady(function () {
        var iframe = document.getElementsByTagName("iframe");
        var src, worked;
        for (var i = 0; i < iframe.length; i++) {
            src = tryToGetAttribute(iframe[i], "mmsrc");
            worked = tryToGetAttribute(iframe[i], "mmworked");
            var oifrspm = spmapi(iframe[i]);
            var sifrspm = [oifrspm.a || '0', oifrspm.b || '0', oifrspm.c || '0', oifrspm.d || '0', oifrspm.e || '0'].join(".");

            if (src && !worked) {
                if (bInIframe) {
                    //在iframe里时，第二段的spm值里的e位要去掉
                    sifrspm = [oifrspm.a || '0', oifrspm.b || '0', oifrspm.c || '0', oifrspm.d || '0'].join(".");
                    sifrspm = fnCurrentURLSpm() + "_" + sifrspm;
                }

                iframe[i].src = fnUpdateHrefWithSPMId(fnReplacePid(src), sifrspm);
                iframe[i].setAttribute("mmworked", "mmworked");
            }else{
                //为了保持d位序列的延续，没有加入mmsrc的也要产生编号
                iframe[i].setAttribute(sATTR_DATA_SPM_ACT_ID, sifrspm);
            }
        }
    });

})();



/*****************
 ** WEBPACK FOOTER
 ** ./components/wlog/src/spmact_wap.js
 ** module id = 17
 ** module chunks = 0
 **/